import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-table-record-count',
  templateUrl: './table-record-count.component.html',
  styleUrls: ['./table-record-count.component.scss']
})
export class TableRecordCountComponent implements OnInit {
  @Input() recordCount = 0;
  @Input() singularLabel = '';
  @Input() multipleLabel = '';
  @Input() displayWhenZero = false;

  constructor() {}

  ngOnInit() {}
}
